document.querySelectorAll( '[data-accordion]' ).forEach( ( accordion ) => {
    const toggle = accordion.querySelector( '[data-accordion-toggle]' );
    const content = accordion.querySelector( '[data-accordion-content]' );
    const icon = accordion.querySelector( '[data-accordion-icon]' );

    toggle.addEventListener( 'click', () => {
        const isNowHidden = content.classList.toggle( 'hidden' );
        toggle.setAttribute( 'aria-expanded', ! isNowHidden );
        icon.textContent = isNowHidden ? '+' : '−';
        toggle.classList.toggle( 'bg-primary', ! isNowHidden );
        toggle.classList.toggle( 'text-white', ! isNowHidden );
        toggle.classList.toggle( 'bg-bg-gray', isNowHidden );
        toggle.classList.toggle( 'text-heading', isNowHidden );
    } );
} );
